import StyledModal from '@/components/StyledModal';
import { Button, ModalBody, ModalFooter, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export type Entity = {
  id: string;
  name: string;
  slug: string;
  type: 'Action' | 'Block' | 'Project' | 'Category' | 'Person';
};

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  entity: Entity;
};

function CreateEntityModal({ isOpen, onCancel, entity }: Props) {
  const { t } = useTranslation('CreateEntityModal');
  const entityType = t(`entityTypes.${entity.type.toLowerCase()}`);
  const navigate = useNavigate();

  return (
    <StyledModal isOpen={isOpen} onClose={onCancel} size="3xl" title={t('title.entityCreated', { entityType })}>
      <ModalBody>
        <Text color="text-primary" fontSize="lg" fontWeight={500}>
          {t('messages.viewEntityNow', { entityType })}
        </Text>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onCancel} size="lg" variant="secondary">
          {t('buttons.close')}
        </Button>
        <Button
          onClick={() => {
            onCancel();
            navigate(entity.slug);
          }}
          size="lg"
          variant="primary"
        >
          {t('buttons.viewEntity', { entityType })}
        </Button>
      </ModalFooter>
    </StyledModal>
  );
}

export default CreateEntityModal;
